import { useQuery } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { getDocumentsExternalFiles } from '../requests';
import type { GetDocumentsExternalFilesRequestType } from '../types';

export const useGetDocumentsExternalFiles = (
  documentId?: GetDocumentsExternalFilesRequestType['documentId'],
) =>
  useQuery({
    queryKey: [API_QUERY_KEYS.documentsExternalFiles, { documentId }],
    queryFn: () => getDocumentsExternalFiles(documentId!),
    enabled: !!documentId,
  });
